import React from 'react'

// Antd
import { Typography, Divider } from 'antd'

interface flagListHeader {
  heading: string
  title: string | null
  description: string | null
  button: boolean
  disabled?: boolean
}

const FlagListHeader: React.FC<flagListHeader> = ({ title, description, heading, button }) => {
  return (
    <div style={{ marginBottom: 20 }}>
      <Typography.Title level={2}>{heading}</Typography.Title>
      <Divider style={{ border: '1px solid lightgrey' }} />
      {title !== null && <Typography.Title level={4}>{title}</Typography.Title>}
      {description !== null && (
        <div className={button ? 'flaglist-description' : ''}>
          <Typography.Text>
            {description.split('\n').map((l) => {
              return (
                <>
                  {l}
                  <br />
                </>
              )
            })}
          </Typography.Text>
        </div>
      )}

      {/* "Initiera uppföljning"-knappen är borttagen (#30 PR 5). Den nådde bara
          /app/nytt-arende, och av 40 användningar av den här headern passerade EN
          `button={true}` — den parkerade /app/handlaggare, utan menypost och med
          platshållartext. Propen `button` finns kvar eftersom den även styr en
          css-klass på beskrivningen. */}
    </div>
  )
}

export default FlagListHeader
